var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: _vm.id } }, [
    _vm.inputLabel && !_vm.hiddenLabel
      ? _c("label", { class: _vm.customLabelClass }, [
          _vm._v("\n    " + _vm._s(_vm.inputLabel) + "\n    "),
          _vm.isMandatory
            ? _c("span", { staticClass: "color-red" }, [_vm._v("* ")])
            : _vm._e(),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", [
      _c(
        "div",
        {
          staticClass: "position-relative w-100 m-0",
          attrs: { id: _vm.idDropdown },
        },
        [
          _c("div", { class: _vm.inputClass }, [
            _c("div", { staticClass: "d-flex" }, [
              _c("input", {
                staticClass: "form-control inputAccordionForm",
                class:
                  _vm.errorIndicatorHighlight + " " + _vm.customHeightClass,
                attrs: {
                  id: _vm.idDropdownData,
                  type: "text",
                  disabled: _vm.disabled,
                  placeholder: _vm.placeholderValue,
                  autocomplete: "my-field-name",
                },
                domProps: { value: _vm.value },
                on: {
                  click: _vm.resetSelection,
                  input: function ($event) {
                    return _vm.$emit("input", $event.target.value)
                  },
                  blur: function ($event) {
                    return _vm.verifyIncorrectValue()
                  },
                },
              }),
              _vm._v(" "),
              _vm.inputIcon
                ? _c("i", {
                    staticClass: "input-icon fs-14px",
                    class: _vm.inputIcon,
                  })
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showDropdownVisible(),
                    expression: "showDropdownVisible()",
                  },
                ],
                staticClass: "contact-dropdown-list",
                class: _vm.dropdownStyle,
              },
              _vm._l(_vm.itemListFiltered, function (item) {
                return _c(
                  "div",
                  {
                    key: item.id,
                    staticClass: "contact-dropdown-item itemContact",
                    on: {
                      click: function ($event) {
                        return _vm.selectItem(item)
                      },
                      mousedown: function ($event) {
                        return _vm.selectItem(item)
                      },
                    },
                  },
                  [
                    _c("div", [
                      _c(
                        "label",
                        { staticClass: "font-weight-normal cursor" },
                        [_vm._v(_vm._s(item.name))]
                      ),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c(
                        "label",
                        { staticClass: " font-weight-normal cursor" },
                        [_vm._v(_vm._s(item.identifier))]
                      ),
                    ]),
                  ]
                )
              }),
              0
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _vm.componentMandatoryErrorIndicator
        ? _c(
            "div",
            {
              staticClass: "color-red",
              class: _vm.customErrorClass,
              attrs: { id: _vm.idError },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$t("errors.is_mandatory", {
                      mandatoryValue: _vm.inputLabel.toLowerCase(),
                    })
                  ) +
                  "\n    "
              ),
            ]
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }